"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
//
// styles
//
const StyledLabel_1 = require("../StyledLabel");
const StyledInvalidFeedback_1 = require("../../../onboarding/OnboardingForm/StyledInvalidFeedback");
const StyledSubdomain_1 = require("../StyledSubdomain");
const StyledDomainInput_1 = require("../StyledDomainInput");
const StyledSubdomainContainer_1 = require("../StyledSubdomainContainer");
const SubdomainInput = (props) => {
    return (react_1.default.createElement("div", { className: 'row g-3' },
        react_1.default.createElement("div", { className: 'col-12 mb-3' },
            react_1.default.createElement(StyledLabel_1.StyledLabel, { className: 'form-label', htmlFor: props.id }, props.label),
            react_1.default.createElement(StyledSubdomainContainer_1.StyledSubdomainContainer, { className: props.error ? 'invalid' : '' },
                react_1.default.createElement(StyledDomainInput_1.StyledDomainInput, { className: 'form-control', id: props.id, onBlur: props.onBlur, onChange: props.onInputChange, type: 'text' }),
                react_1.default.createElement(StyledSubdomain_1.StyledSubdomain, { className: 'domain-text' }, `.${process.env.ROOT_HOSTED_DOMAIN
                    ? process.env.ROOT_HOSTED_DOMAIN
                    : 'mymalomo.lol'}`)),
            props.error ? (react_1.default.createElement(StyledInvalidFeedback_1.StyledInvalidFeedback, { className: 'invalid-feedback' }, props.error)) : null)));
};
SubdomainInput.propTypes = {
    error: prop_types_1.default.string,
    id: prop_types_1.default.string,
    label: prop_types_1.default.string,
    onBlur: prop_types_1.default.func,
    onInputChange: prop_types_1.default.func
};
exports.default = SubdomainInput;
